import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SEOHead from '../../components/SEOHead';
import './ServicePage.css';

const SEO = {
  title: 'Myntra Seller Management Services | Mad Marketing Club',
  description: 'Myntra fashion marketplace seller management services — catalog optimization, Myntra Ads, brand storefront setup & fashion category growth. Coming soon. Free consultation.',
  canonical: 'https://madmarketingclub.com/services/myntra',
  breadcrumb: [
    { name: 'Home', url: 'https://madmarketingclub.com/' },
    { name: 'Services', url: 'https://madmarketingclub.com/#services' },
    { name: 'Myntra', url: 'https://madmarketingclub.com/services/myntra' },
  ],
  service: { name: 'Myntra Seller Management Services', type: 'Myntra Marketplace Management' },
};

export default function MyntraPage() {
  return (
    <>
      <SEOHead {...SEO} />
      <Header />
      <main className="sp-page">
        <nav className="sp-breadcrumb" aria-label="Breadcrumb">
          <div className="sp-breadcrumb-inner">
            <Link to="/">Home</Link>
            <span>/</span>
            <Link to="/#services">Services</Link>
            <span>/</span>
            <span>Myntra</span>
          </div>
        </nav>
        <div className="sp-coming-soon">
          <div className="sp-coming-soon-inner">
            <div className="sp-coming-soon-icon">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
            </div>
            <div className="sp-label">Service Page</div>
            <h1 className="sp-coming-soon-title">Myntra — Coming Soon</h1>
            <p className="sp-coming-soon-desc">This service page is currently being built. Check back shortly for our full Myntra Fashion Marketplace service details.</p>
            <Link to="/" className="sp-btn-primary">← Back to Home</Link>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
